import React from "react";
import "./SoftwareSkill.css";
import { Tooltip } from "react-bootstrap";

class SoftwareSkill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTooltip: null,
    };
  }

  handleMouseEnter = (skillName) => {
    this.setState({ activeTooltip: skillName });
  };

  handleMouseLeave = () => {
    this.setState({ activeTooltip: null });
  };

  render() {
    return (
      <div>
        <div className="software-skills-main-div">
          <ul className="dev-icons">
            {this.props.logos.map((logo) => {
              const isActive = this.state.activeTooltip === logo.skillName;

              return (
                <li
                  key={logo.skillName}
                  className="software-skill-inline"
                  name={logo.skillName}
                  onMouseEnter={() => this.handleMouseEnter(logo.skillName)}
                  onMouseLeave={this.handleMouseLeave}
                >
                  {logo.fontAwesomeClassname && (
                    <span
                      className="iconify"
                      data-icon={logo.fontAwesomeClassname}
                      style={logo.style}
                      data-inline="false"
                    ></span>
                  )}
                  {!logo.fontAwesomeClassname && logo.imageSrc && (
                    <img
                      className="skill-image"
                      style={logo.style}
                      src={`${process.env.PUBLIC_URL}/skills/${logo.imageSrc}`}
                      alt={logo.skillName}
                    />
                  )}
                  {isActive && (
                    <div className="skill-tooltip">
                      <strong>{logo.skillName}</strong>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default SoftwareSkill;
